import Txt from "../../../components/typography/Txt";
import { SZ } from "../../sizersShared/sizerUi";

/**
 * The blocking inline error under a field the 422 gate named.
 *
 * `POST /pricing/scenario/dscr_quick` returns `missingRequirements[]` for inputs
 * whose absence would silently skip an LLPA table and MISPRICE the loan. That is
 * a gate, not a failure, and the fix is always at a specific field — so it
 * renders here rather than as a page-level message.
 */
export default function GateError({ fields, name }) {
  const hit = (fields || {})[name];
  if (!hit) return null;
  return <Txt sx={{ fontSize: 11.5, color: SZ.bad, mt: "5px" }}>{hit}</Txt>;
}
